import { useEffect, useState } from "react";
import {
  CalenderButtonWrapper,
  CalenderGrid,
  CalenderHeader,
  CalenderHeaderDate,
  CalenderWrapper,
} from "./style";
import { EventScheduleCountResponse } from "../../../../../api/event-schedule";
import { getTodayDate } from "../../../../../utils/date";
import {
  formatLabelDate,
  getDateFromDayNumber,
  isDaySelected,
} from "../../utils/calender";
import { DaysDto } from "../../hook/useSchedule";

interface CalenderProps {
  date: string;
  setDate: (value: string) => void;
  setCalenderOpen: (value: boolean) => void;
  renderDays: (currentMonthLabel: string) => DaysDto;
  getCountList: (currentMonthLabel?: string) => void;
  countList: EventScheduleCountResponse[];
  year: number;
  month: number;
}

const EventScheduleCalender = ({
  setCalenderOpen,
  date,
  setDate,
  renderDays,
  getCountList,
  countList,
  year,
  month,
}: CalenderProps) => {
  const [days, setDays] = useState<
    { day: number; week: string; count: number }[]
  >([]);
  const [daysEmpty, setDaysEmpty] = useState<number[]>([]);
  const [selectedDay, setSelectedDay] = useState<string>("");
  const paddedMonth = String(month).padStart(2, "0");
  const [currentMonthLabel, setCurrentMonthLabel] = useState<string>(
    date ? date : `${year}-${paddedMonth}-02`
  );
  const week = ["일", "월", "화", "수", "목", "금", "토"];

  const isToday = (day: number) => {
    const [curYear, curMonth] = currentMonthLabel.split("-");
    const [todayYear, todayMonth, todayDay] = getTodayDate().split("-");
    return (
      curMonth === todayMonth && curYear === todayYear && +todayDay === day
    );
  };

  const changeMonth = (offset: number) => {
    const current = new Date(currentMonthLabel);
    current.setMonth(current.getMonth() + offset);
    const newLabel = current.toISOString().split("T")[0];
    const [year, month, _] = newLabel.split("-");
    if (+year <= 2025 && +month <= 6) return;
    setCurrentMonthLabel(newLabel);
  };

  const handleDate = (day: number) => {
    const newDate = getDateFromDayNumber(currentMonthLabel, day);
    setSelectedDay(newDate);
  };

  useEffect(() => {
    getCountList(currentMonthLabel);
  }, [currentMonthLabel]);

  useEffect(() => {
    if (!currentMonthLabel) return;
    const days = renderDays(currentMonthLabel);
    setDays(days.dayList);
    setDaysEmpty(days.daysEmpty);
  }, [countList, currentMonthLabel]);

  useEffect(() => {
    if (date) setSelectedDay(date);
  }, [date]);

  const saveDate = () => {
    setDate(selectedDay);
    setCalenderOpen(false);
  };

  const getDayClassName = (day: number) => {
    const classes = ["day"];
    if (isDaySelected(currentMonthLabel, day, selectedDay))
      classes.push("select");
    if (isToday(day)) classes.push("today");
    return classes.join(" ");
  };

  return (
    <CalenderWrapper>
      <CalenderHeader>
        <div className="title">날짜를 선택해주세요. </div>
        <CalenderHeaderDate>
          <div className="arrow" onClick={() => changeMonth(-1)}>
            <img src="/image-web/event/calender-left.svg" alt="left" />
          </div>
          <div className="date">{formatLabelDate(currentMonthLabel)}</div>
          <div className="arrow" onClick={() => changeMonth(1)}>
            <img src="/image-web/event/calender-right.svg" alt="right" />
          </div>
        </CalenderHeaderDate>
      </CalenderHeader>
      <CalenderGrid>
        {week.map((label) => (
          <div key={label} className="label">
            {label}
          </div>
        ))}
        {daysEmpty.map((_, index) => (
          <div key={index} className="empty"></div>
        ))}
        {days.map((day) => (
          <div
            key={day.day}
            className={getDayClassName(day.day)}
            onClick={(e) => {
              e.stopPropagation();
              handleDate(day.day);
            }}
          >
            <div className="count-wrapper">
              {Array.from({ length: day.count }, (_, i) => (
                <div className="count" key={i} />
              ))}
            </div>
            {day.day}
          </div>
        ))}
      </CalenderGrid>
      <CalenderButtonWrapper>
        <div className="button" onClick={() => setCalenderOpen(false)}>
          닫기
        </div>
        <div onClick={() => saveDate()} className="button purple">
          확인
        </div>
      </CalenderButtonWrapper>
    </CalenderWrapper>
  );
};

export default EventScheduleCalender;
